module.exports = __webpack_public_path__ + "img/icon_4_32.2d9f85b9.png";